module.exports = "https://www.gc-qa.gnp.com.mx/a3678bb0a3ce18b5bac3cf72c728e5fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/capitaliza/3.png
// module id = 1015
// module chunks = 0 1